import { ISlide } from "@/models/slide";
import { Heatmap } from "@/models/heatmap";
import { ICase } from "@/models/case";
import { ActiveView } from "@/models/active-view";
import { SystemMode } from "@/models/system-mode";
import { InsightsConfig } from "@/store/models/insights-config";

export interface RootState {
  systemMode: SystemMode;
  config: any;
  insightsConfig: InsightsConfig;
  heatmapsConfig: any;
  queryParams?: URLSearchParams;
  routeParams?: any;
  globals: any;
  cases: ICase[];
  activeCaseId: string;
  slides: ISlide[];
  activeSlideId: string;
  currentSlide: any;
  activeHeatmaps: Heatmap[];
  toggledHeatmaps: Heatmap[];
  isVisible: boolean;
  heatmapsOpacity: number;
  activeView: ActiveView;
  isError: boolean;
  loggedInUserName: string;
  isLoadingHeatmap: boolean;
  isQuantificationLegend: boolean | undefined;
  labeling: object | undefined;
}

export const state: RootState = {
  systemMode: SystemMode.secondread,
  config: {},
  insightsConfig: {
    prostate_measurements: [],
    case_insights: {},
    slide_insights: {},
    labels: {},
  },
  heatmapsConfig: {},
  globals: {},
  cases: [],
  slides: [],
  activeCaseId: "",
  activeSlideId: "",
  currentSlide: {
    id: "" as string,
    name: "" as string,
    dimensions: [0, 0] as [number, number],
    minimapDimensions: [0, 0] as [number, number],
    stain: "" as string,
    tissueType: "" as string,
    heatmaps: [] as object[],
    POIs: [] as object[],
  },
  activeHeatmaps: [],
  toggledHeatmaps: [],
  isVisible: true,
  heatmapsOpacity: 0.5,
  activeView: ActiveView.None,
  isError: false,
  loggedInUserName: "",
  isLoadingHeatmap: false,
  isQuantificationLegend: false,
  labeling: undefined,
};
